module.exports = __webpack_public_path__ + "html/navbar.template.html";